import React, { useState } from 'react';
import PropTypes, { shape } from 'prop-types';
import moment from 'moment';
import styles from './index.module.scss';

import ReviewItem from './ReviewItem';
import Button from '../Button/Button';

const TOTAL_REVIEWS_VISIBLE = 6;

const Reviews = ({ yelpReviews = [], jbReviews }) => {
  const numberOfYelpReviews = yelpReviews.length;
  const numberOfJBReviews = TOTAL_REVIEWS_VISIBLE - numberOfYelpReviews;
  const [jbReviewState, setJbReviewState] = useState(
    jbReviews?.sort((a, b) => b.created_at - a.created_at).slice(0, numberOfJBReviews)
  );
  const [showLoadMore, setShowLoadMore] = useState(jbReviews && jbReviews.length > numberOfJBReviews);

  const loadMore = () => {
    setJbReviewState(jbReviews);
    setShowLoadMore(false);
  };

  const mergedReviews = [...yelpReviews, ...jbReviewState ?? []];
  const unifiedReviews = mergedReviews.map((item) => ({
    rating: item.rating,
    id: item.id,
    momentObject: moment(item.time_created || item.created_at),
    text: item.text || item.notes,
    user: item.user,
    isJobox: !item.user,
    url: item.url,
  })).sort((a, b) => b.momentObject.diff(a.momentObject));

  return (
    <div className={styles.container}>
      <h4>Reviews</h4>
      {unifiedReviews && unifiedReviews.map((item) => <ReviewItem key={item.id} {...item} />)}
      {showLoadMore
        && <Button className={styles.button} onClick={loadMore} variant="secondary">Load more reviews</Button>}
    </div>
  );
};

Reviews.propTypes = {
  yelpReviews: PropTypes.arrayOf(shape({
    time_created: PropTypes.string,
    user: PropTypes.object,
    id: PropTypes.string,
  })),
  jbReviews: PropTypes.arrayOf(shape({
    created_at: PropTypes.number,
    id: PropTypes.number,
    rating: PropTypes.number,
    notes: PropTypes.string,
  }))
};

export default Reviews;
